'use strict';

var _ = require('lodash');

var DEFAULT_OPTIONS = {
  width: 200,
};

function LatLngRenderer (map, options) {
  this._map = map;
  this._options = _.extend(DEFAULT_OPTIONS, options);
  
  this._showMouseLatLng = _.throttle(this._showMouseLatLng.bind(this), 50);
  
  this._createElement();
  this._registerListeners();
  this._showMapLatLng();
}

LatLngRenderer.prototype = {

  getElement: function () {
    return this._element;
  },

  /**
   * Should be called when the $scope is destroyed
   */
  removeListeners: function () {
    this._map.off('move', this._showMapLatLng, this);
    this._map.off('mousemove', this._showMouseLatLng, this);
  },

  _createElement: function () {
    var tpl = [
      '<span>@</span>',
      '<span class="lat"></span>',
      '<span class="lng"></span>',
      // '<span class="zoom"></span>',
    ].join('');

    this._element = angular.element(tpl);
  },

  _registerListeners: function () {
    this._map.on('move', this._showMapLatLng, this);
    this._map.on('mousemove', this._showMouseLatLng, this);
  },

  _showMapLatLng: function () {
    var latlng = this._map.getCenter();
    this._updatePosition(latlng.lat, latlng.lng);
  },

  _showMouseLatLng: function (e) {
    this._updatePosition(e.latlng.lat, e.latlng.lng);
  },

  _updatePosition: function (lat, lng) {
    // var zoom = this._map.getZoom();
    var latEl = this._element.eq(1);
    var lngEl = this._element.eq(2);
    // var zoomEl = this._element.eq(3);

    latEl.text(lat.toFixed(7) + ',');
    lngEl.text(lng.toFixed(7));
    // zoomEl.text(zoom);
  }
};

module.exports = LatLngRenderer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/controls/lib/LatLngRenderer.js